// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetHouseStatsDesktopRequest,
  TGetHouseStatsDesktopModel,
  IMappers,
  TGetHouseStatsDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingHouseStatsDesktopResponse } from '../../entities/get_newbuilding_house_stats_desktop/GetNewbuildingHouseStatsDesktopResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetHouseStatsDesktopModel(parameters: TGetHouseStatsDesktopRequest): TGetHouseStatsDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-card',
    pathApi: '/v1/get-house-stats-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetHouseStatsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetHouseStatsDesktopRequest;
}

export async function fetchGetHouseStatsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseStatsDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetHouseStatsDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHouseStatsDesktopModel(parameters),
    config,
  )) as FetchResponse<TGetHouseStatsDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingHouseStatsDesktopResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetHouseStatsDesktopResponse>;
}
